export const DATE_FORMATS = {
  SHORT_MONTH_FULL_DAY_FULL_YEAR: 'MMM DD, Y',
  FULL_DAY_SHORT_MONTH_FULL_SHORT_YEAR: 'DD MMM YY',
  SHORT_MONTH_FULL_DAY_FULL_YEAR_TIME: 'MMM DD, Y, h:mm A',
  FORMAT_PATTERN_1: 'YYYY-MM-DD',
  FORMAT_PATTERN_2: 'MMM Do, YYYY',
  FORMAT_PATTERN_3: 'ddd, D',
  SHORT_MONTH_DAY: 'MMM D',
  DAY_OF_WEEK_SHORT_MONTH_DAY: 'ddd, MMM D'
};
